import { StorageDriver } from './storage-driver.type.js';

export const getStorageDrivers = (): Array<StorageDriver> => {
    if (!window.localStorage && !window.sessionStorage) {
        return [];
    }
    return [
        ...(!window.localStorage
            ? []
            : [
                  {
                      name: 'localStorage',
                      key: (i: number) =>
                          window.localStorage.key.call(window.localStorage, i),
                      length: () => window.localStorage.length,
                      set: window.localStorage.setItem.bind(
                          window.localStorage
                      ),
                      get: window.localStorage.getItem.bind(
                          window.localStorage
                      ),
                      remove: window.localStorage.removeItem.bind(
                          window.localStorage
                      ),
                      clear: window.localStorage.clear.bind(
                          window.localStorage
                      ),
                  },
              ]),
        ...(!window.sessionStorage
            ? []
            : [
                  {
                      name: 'sessionStorage',
                      key: (i: number) =>
                          window.sessionStorage.key.call(
                              window.sessionStorage,
                              i
                          ),
                      length: () => window.localStorage.length,
                      set: window.sessionStorage.setItem.bind(
                          window.sessionStorage
                      ),
                      get: window.sessionStorage.getItem.bind(
                          window.sessionStorage
                      ),
                      remove: window.sessionStorage.removeItem.bind(
                          window.sessionStorage
                      ),
                      clear: window.sessionStorage.clear.bind(
                          window.sessionStorage
                      ),
                  },
              ]),
    ];
};
